import { I18nInterface } from '../../interfaces/i18n/i18n-interface';

export class I18nModel implements I18nInterface {
  defaultLang: string = '';
  languages: string[] = new Array<string>();

  constructor(init?: Partial<I18nModel>) {
    Object.assign(this, init);
  }
}
